import Dashboard from "@higher/models/Dashboard";
import { stateSubscriptionById } from "./stateSubscriptionById";

const DashboardsCollection = "dashboards";

export default stateSubscriptionById<Dashboard>(
  "DashboardById",
  DashboardsCollection
);
